@if (loadingGenerico === true) {
  <div [ngClass]="{'body-alert' : showOverlay }">
    <div class="text-center" [ngClass]="{'div-alert' : showOverlay }">
      <output class="spinner-border c-primary" aria-live="polite">
        <span class="visually-hidden" [innerHTML]="messageString"></span>
      </output>
      <p class="legenda-spinner mb-0" [innerHTML]="messageString"></p>
      @if (buttons?.length > 0) {
        <div class="mt-3">
          @for (button of buttons; track button) {
            <button
              [ngClass]="button.ngClass"
              [innerHTML]="button.content"
              (click)="button.click && button.click($event)"
            ></button>
          }
        </div>
      }
    </div>
  </div>
}
